import React, { FC, ReactNode } from "react";
import "./flex.css";

interface FlexProps {
  children?: ReactNode;
  className?: string;
}

/**
 * Flex component
 */
export const Flex: FC<FlexProps> = ({ children, className }) => {
  return <div className={`Flex ${className}`}>{children}</div>;
};
